'use es6';

import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import PropTypes from 'prop-types';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorTextInput = props => {
  const {
    className,
    'data-selenium-test': dataSeleniumTest,
    error,
    onChange,
    onBlur,
    value
  } = props;
  const isError = error.get('error');
  const errorMessage = error.get('message');
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsx(UITextInput, {
      autoFocus: true,
      className: className,
      "data-selenium-test": dataSeleniumTest,
      onBlur: onBlur,
      onChange: onChange,
      value: value
    })
  });
};
FilterOperatorTextInput.propTypes = {
  className: PropTypes.string,
  'data-selenium-test': PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};
export default FilterOperatorTextInput;